<template>
	<div class="map-legend map-routes-providers">
		<ul class="map-legend-list">
			<li>
				<span class="route-provider-line default"></span>
				<span>Нет маршрута</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.default || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line custom"></span>
				<span>Вручную</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.custom || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line mapbox"></span>
				<span>Mapbox</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.mapbox || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line google"></span>
				<span>Google</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.google || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line bing"></span>
				<span>Bing</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.bing || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line mapQuest"></span>
				<span>MapQuest</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.mapQuest || 0 }}</span>
			</li>
			<li>
				<span class="route-provider-line skobbler"></span>
				<span>Skobbler</span>
				<span class="route-provider-line-details is-pulled-right">{{ providers.skobbler || 0 }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	import countBy from 'lodash/countBy';

    export default {
      props: [
        'app',
        'routePaths'
	  ],
      watch: {
        routePaths: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        }
      },
      data () {
        return {
        }
      },
      computed: {
        providers() {
          return countBy(this.routePaths, 'provider');
		}
	  },
      updated: function () {
        // this.$emit('update:objects', this.items);
      },
	  methods: {
	  }
    }
</script>